export default "__VITE_ASSET__BG$nE5jF__"